module.exports = __webpack_public_path__ + "static/media/docx-icon.38876692.svg";